/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import { getBlocks } from 'news/reducers/edito';
import EditoApp from 'edito/App';
import * as EditoActions from 'news/actions/edito';

type Props = {
  blocks: Array<EditorialBlock>,
  updateBlocks: (blocks: Array<EditorialBlock>) => void,
};

const mapStateToProps = state => ({
  blocks: getBlocks(state),
});

const EditoCard = ({ blocks, updateBlocks }: Props) => (
  <EditoApp
    mode="production"
    blocks={blocks}
    onUpdate={updateBlocks}
    attached
  />
);

export default connect(mapStateToProps, {
  updateBlocks: EditoActions.updateBlocks,
})(EditoCard);



// WEBPACK FOOTER //
// ./src/modules/news/components/EditoCard.js